/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const potentialOpenPositionMatches = /* GraphQL */ `query PotentialOpenPositionMatches {
  potentialOpenPositionMatches {
    id
    name
    company {
      id
      name
      url
      logoUrl
      summary
      __typename
    }
    titleType
    role
    active
    experience
    diagnostics {
      items {
        id
        openPositionId
        diagnosticId
        diagnostic {
          id
          name
          assessment
          description
          type
          category
          image
          openPositions {
            nextToken
            __typename
          }
          __typename
        }
        position {
          id
          name
          company {
            id
            name
            url
            logoUrl
            summary
            __typename
          }
          titleType
          role
          active
          experience
          diagnostics {
            nextToken
            __typename
          }
          skills {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        __typename
      }
      nextToken
      __typename
    }
    skills {
      items {
        id
        openPositionId
        skillId
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PotentialOpenPositionMatchesQueryVariables,
  APITypes.PotentialOpenPositionMatchesQuery
>;
export const listMainSkillsWithOpenPositions = /* GraphQL */ `query ListMainSkillsWithOpenPositions($maxExperience: Experience) {
  listMainSkillsWithOpenPositions(maxExperience: $maxExperience) {
    id
    name
    type
    area
    active
    frequency
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMainSkillsWithOpenPositionsQueryVariables,
  APITypes.ListMainSkillsWithOpenPositionsQuery
>;
export const jobMatchesSummary = /* GraphQL */ `query JobMatchesSummary {
  jobMatchesSummary {
    fullMatch
    role
    titleType
    level
    skills {
      id
      name
      type
      area
      active
      frequency
      createdAt
      updatedAt
      __typename
    }
    reasonCode
    missingSkills {
      id
      name
      type
      area
      active
      frequency
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.JobMatchesSummaryQueryVariables,
  APITypes.JobMatchesSummaryQuery
>;
export const getEngineerDiagnostic = /* GraphQL */ `query GetEngineerDiagnostic($id: ID!) {
  getEngineerDiagnostic(id: $id) {
    id
    engineerId
    diagnosticId
    order
    assessmentUrl
    canceledAt
    readyAt
    diagnostic {
      id
      name
      assessment
      description
      type
      category
      image
      openPositions {
        items {
          id
          openPositionId
          diagnosticId
          diagnostic {
            id
            name
            assessment
            description
            type
            category
            image
            __typename
          }
          position {
            id
            name
            titleType
            role
            active
            experience
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEngineerDiagnosticQueryVariables,
  APITypes.GetEngineerDiagnosticQuery
>;
export const listEngineerDiagnostics = /* GraphQL */ `query ListEngineerDiagnostics(
  $filter: ModelEngineerDiagnosticFilterInput
  $limit: Int
  $nextToken: String
) {
  listEngineerDiagnostics(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      engineerId
      diagnosticId
      order
      assessmentUrl
      canceledAt
      readyAt
      diagnostic {
        id
        name
        assessment
        description
        type
        category
        image
        openPositions {
          items {
            id
            openPositionId
            diagnosticId
            __typename
          }
          nextToken
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEngineerDiagnosticsQueryVariables,
  APITypes.ListEngineerDiagnosticsQuery
>;
export const getEngineer = /* GraphQL */ `query GetEngineer($id: ID!) {
  getEngineer(id: $id) {
    id
    owner
    experience
    positionTitleTypes
    skillIds
    cv {
      bucket
      region
      key
      pathPrefix
      __typename
    }
    linkedIn
    phase
    utm {
      source
      medium
      campaign
      term
      content
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEngineerQueryVariables,
  APITypes.GetEngineerQuery
>;
export const listEngineers = /* GraphQL */ `query ListEngineers(
  $filter: ModelEngineerFilterInput
  $limit: Int
  $nextToken: String
) {
  listEngineers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      owner
      experience
      positionTitleTypes
      skillIds
      cv {
        bucket
        region
        key
        pathPrefix
        __typename
      }
      linkedIn
      phase
      utm {
        source
        medium
        campaign
        term
        content
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEngineersQueryVariables,
  APITypes.ListEngineersQuery
>;
export const getJobMatch = /* GraphQL */ `query GetJobMatch($id: ID!) {
  getJobMatch(id: $id) {
    id
    engineerId
    openPositionId
    engineerInterest
    status
    inactiveMatchReason
    openPosition {
      id
      name
      company {
        id
        name
        url
        logoUrl
        summary
        __typename
      }
      titleType
      role
      active
      experience
      diagnostics {
        items {
          id
          openPositionId
          diagnosticId
          diagnostic {
            id
            name
            assessment
            description
            type
            category
            image
            __typename
          }
          position {
            id
            name
            titleType
            role
            active
            experience
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      skills {
        items {
          id
          openPositionId
          skillId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetJobMatchQueryVariables,
  APITypes.GetJobMatchQuery
>;
export const listJobMatchs = /* GraphQL */ `query ListJobMatchs(
  $filter: ModelJobMatchFilterInput
  $limit: Int
  $nextToken: String
) {
  listJobMatchs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      engineerId
      openPositionId
      engineerInterest
      status
      inactiveMatchReason
      openPosition {
        id
        name
        company {
          id
          name
          url
          logoUrl
          summary
          __typename
        }
        titleType
        role
        active
        experience
        diagnostics {
          items {
            id
            openPositionId
            diagnosticId
            __typename
          }
          nextToken
          __typename
        }
        skills {
          items {
            id
            openPositionId
            skillId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListJobMatchsQueryVariables,
  APITypes.ListJobMatchsQuery
>;
export const listEngineersByOwner = /* GraphQL */ `query ListEngineersByOwner(
  $owner: String
  $id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelEngineerFilterInput
  $limit: Int
  $nextToken: String
) {
  listEngineersByOwner(
    owner: $owner
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      owner
      experience
      positionTitleTypes
      skillIds
      cv {
        bucket
        region
        key
        pathPrefix
        __typename
      }
      linkedIn
      phase
      utm {
        source
        medium
        campaign
        term
        content
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEngineersByOwnerQueryVariables,
  APITypes.ListEngineersByOwnerQuery
>;
export const listJobMatchesByEngineer = /* GraphQL */ `query ListJobMatchesByEngineer(
  $engineerId: ID
  $openPositionId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelJobMatchFilterInput
  $limit: Int
  $nextToken: String
) {
  listJobMatchesByEngineer(
    engineerId: $engineerId
    openPositionId: $openPositionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      engineerId
      openPositionId
      engineerInterest
      status
      inactiveMatchReason
      openPosition {
        id
        name
        company {
          id
          name
          url
          logoUrl
          summary
          __typename
        }
        titleType
        role
        active
        experience
        diagnostics {
          items {
            id
            openPositionId
            diagnosticId
            __typename
          }
          nextToken
          __typename
        }
        skills {
          items {
            id
            openPositionId
            skillId
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListJobMatchesByEngineerQueryVariables,
  APITypes.ListJobMatchesByEngineerQuery
>;
export const getTechnicalSkill = /* GraphQL */ `query GetTechnicalSkill($id: ID!) {
  getTechnicalSkill(id: $id) {
    id
    name
    type
    area
    active
    frequency
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTechnicalSkillQueryVariables,
  APITypes.GetTechnicalSkillQuery
>;
export const listTechnicalSkills = /* GraphQL */ `query ListTechnicalSkills(
  $filter: ModelTechnicalSkillFilterInput
  $limit: Int
  $nextToken: String
) {
  listTechnicalSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      type
      area
      active
      frequency
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTechnicalSkillsQueryVariables,
  APITypes.ListTechnicalSkillsQuery
>;
